import React, { useEffect } from 'react';
import {
  Button,
  Icon,
  LottiePlayer,
  ModalIsland,
} from '@saviynt/design-system';

import { useChatOverlayContext } from '../../../context/chatOverlayContext';
import { useGeneratingContentLoadingMessages } from '../../../hooks';
import { getAppropriateGeneratingContentLoadingMsgs } from '../../../services/ispmUtil';
import { useInvertedLocalize } from '../../../utils/localization';
import { invertedMessages } from '../../../utils/messages';

import './GeneratingContent.css';

function GeneratingContent(): JSX.Element {
  const l = useInvertedLocalize(invertedMessages);

  const { chatOverlayState, updateChatOverlayState } = useChatOverlayContext();

  const { loaderTitleText, loaderDescriptionText } =
    useGeneratingContentLoadingMessages(
      getAppropriateGeneratingContentLoadingMsgs(l)
    );

  useEffect(
    () => () => {
      /* Clearing or resetting the modal visibility on unmount */
      updateChatOverlayState('isWarningModalOpen', false);
    },
    [updateChatOverlayState]
  );

  return (
    <>
      <section className='Ispm-GeneratingContent'>
        <div className='Ispm-GeneratingContent-contentWrapper'>
          <div className='Ispm-GeneratingContent-contentWrapper-loader'>
            <LottiePlayer
              kind='saviLoader'
              style={{ width: '7.5rem', height: '7.5rem' }}
            />
          </div>
          <div className='Ispm-GeneratingContent-contentWrapper-text'>
            <div className='Ispm-GeneratingContent-contentWrapper-text-primary'>
              {loaderTitleText}
            </div>
            <div className='Ispm-GeneratingContent-contentWrapper-text-secondary'>
              {loaderDescriptionText}
            </div>
          </div>

          <div className='Ispm-GeneratingContent-contentWrapper-button'>
            <Button
              size='medium'
              kind='outlined'
              leftIcon={
                <Icon kind='StopProcess' size='medium' color='indigo-700' />
              }
              onClick={() => {
                updateChatOverlayState('isWarningModalOpen', true);
              }}>
              {l('Stop Processing')}
            </Button>
          </div>
        </div>
      </section>
      {chatOverlayState.isWarningModalOpen && (
        <ModalIsland
          kind='warning'
          alertTitle={l('Are you sure?')}
          alertSubtitle={l(
            'Stopping processing may result in a charge of credits. Do you still want to continue?'
          )}
          onClose={() => updateChatOverlayState('isWarningModalOpen', false)}
          isOpen={chatOverlayState.isWarningModalOpen}
          primaryButton={
            <Button type='button' kind='outlined' size='medium'>
              {l('Stop Processing')}
            </Button>
          }
          secondaryButton={
            <Button
              type='button'
              kind='ghost'
              size='medium'
              onClick={() => {
                updateChatOverlayState('isWarningModalOpen', false);
              }}>
              {l('Cancel')}
            </Button>
          }
        />
      )}
    </>
  );
}

export default GeneratingContent;
